import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@bd/bdcore-utilities';
import { css, cx } from '@bd/bdui-styles/emotion';


const styles = css`
  position: relative;
  overflow: hidden;
  @supports (object-fit: cover) and (object-position: center center) {
    position: static;
  }
  .ImageWrapper_image {
    display: block;
    position: absolute;
    top: -100%;
    right: -100%;
    bottom: -100%;
    left: -100%;
    min-width: 100%;
    min-height: 100%;
    margin: auto;
    @supports (object-fit: cover) and (object-position: center center) {
      position: static;
      object-fit: cover;
      object-position: center center;
      width: 100%;
      height: 100%;
      min-width: 0;
      min-height: 0;
      margin: 0;
    }
  }
`;

function ImageWrapper({ className, image, fallback }) {
  return (
    <div className={cx(styles, className)}>
      {
        image.src &&
        <Image
          className="ImageWrapper_image ImageWrapper_image-primary"
          src={image.src}
          alt={image.alt || ''}
          width={image.width}
          height={image.height}
        />
      }
      {
        !image.src &&
        <img
          className="ImageWrapper_image ImageWrapper_image-fallback"
          src={fallback.src || '/images/copy-fallback.jpg'}
          alt={
            fallback.src ? (fallback.alt || '') :
            'modern high chairs line a large island in the middle of an all-white kitchen'
          }
        />
      }
    </div>
  );
}

ImageWrapper.propTypes = {
  className: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  fallback: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
  }),
};

ImageWrapper.defaultProps = {
  className: '',
  image: {
    src: undefined,
    alt: '',
    width: 600,
    height: 600,
  },
  fallback: {},
};

export default ImageWrapper;



// WEBPACK FOOTER //
// ./src/components/ImageWrapper.js